import { useEffect, useState } from 'react';

function useFetchUrl(url, fetchSuccess){
    const [ players, setPlayers ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ isError, setError ] = useState(false);

    useEffect(() => {
        const fetchPlayers = async () => {
            setError(false);
            setLoading(true);
            try {
                const base = process.env.PUBLIC_URL ? `${process.env.REACT_APP_BASE_URL}/wp-content/themes/fc-hockey/` : "";
                const result = await fetch(`${base}${url}`);
                const json = await result.json();
                const processedResult = fetchSuccess(json);
                setPlayers(processedResult);
                setLoading(false);
            }
            catch (error) {
               setError(error);
            }
        }
        fetchPlayers();
    }, [fetchSuccess, url]);
    return [players, loading, isError];
}

export default useFetchUrl;